module.exports = __webpack_public_path__ + "img/SPRINT_GAMING_PNG.6df8f83d.png";